import { TranslationDataContext } from 'articleEditor/contexts/translationProvider';
import { useTranslationFetch } from 'articleEditor/hooks/useTranslationFetch';
import { LanguageContext } from 'lib-knowledge-management-common/contexts/language';
import { ArticleTranslationQuery } from 'lib-knowledge-management-common/graphql';
import { useContext, useEffect, useRef } from 'react';

export const useDefaultTranslation = ():
  | ArticleTranslationQuery['articleTranslation']
  | undefined => {
  const { currentLanguage, defaultLanguage } = useContext(LanguageContext);
  const previousLanguage = useRef(currentLanguage);
  const articleTranslation = useContext(TranslationDataContext);
  const { data: defaultTranslation, refetch } = useTranslationFetch({
    articleId: articleTranslation.articleId,
    languageId: defaultLanguage.languageId,
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    /**
     * We will refetch everytime the current language changes to a non default
     * language (if it's the default language, we already have the value in
     * the articleTranslation). Because this hook is used inside a context, it
     * is rerender every time the context changes, even though the current
     * language didn't change, so we are using a reference to the previous
     * language to avoid refetching when the language didn't change.
     */
    if (
      previousLanguage.current !== currentLanguage &&
      currentLanguage !== defaultLanguage.languageId
    ) {
      refetch();
    }
  }, [currentLanguage, defaultLanguage.languageId, refetch, previousLanguage]);

  return defaultTranslation?.articleTranslation;
};
